<div class="container-fluid py-4">
  <!-- Header -->
  <div class="page-header">
    <div>
      <h2><i class="bi bi-clipboard2-pulse me-2"></i>Prontuários</h2>
      <p class="text-muted mb-0">Registre atendimentos, evoluções e anexe documentos</p>
    </div>
    <button class="btn btn-primary btn-sm" (click)="openModal()">
      <i class="bi bi-plus-circle me-1"></i> Adicionar Prontuário
    </button>
  </div>
  <hr/>

  <!-- Filtros -->
  <div class="card mb-4">
    <div class="card-body">
      <div class="row g-3">
        <div class="col-md-4">
          <input type="text" class="form-control" placeholder="Buscar..."
                 [ngModel]="filter.search" (ngModelChange)="onSearch($event)">
        </div>
        <div class="col-md-3">
          <div class="date-input-wrapper">
            <input #startDateInput type="text" class="form-control"
                   [(ngModel)]="startDateDisplay"
                   (input)="onStartDateInput($event)"
                   placeholder="Data inicial (dd/mm/aaaa)"
                   maxlength="10">
            <button type="button" class="date-picker-btn" (click)="toggleStartDatePicker()">
              <i class="bi bi-calendar3"></i>
            </button>
          </div>
        </div>
        <div class="col-md-3">
          <div class="date-input-wrapper">
            <input #endDateInput type="text" class="form-control"
                   [(ngModel)]="endDateDisplay"
                   (input)="onEndDateInput($event)"
                   placeholder="Data final (dd/mm/aaaa)"
                   maxlength="10">
            <button type="button" class="date-picker-btn" (click)="toggleEndDatePicker()">
              <i class="bi bi-calendar3"></i>
            </button>
          </div>
        </div>
        <div class="col-md-2">
          <button class="btn btn-secondary w-100" (click)="filter.search='';filter.startDate='';filter.endDate='';startDateDisplay='';endDateDisplay='';load()">
            <i class="bi bi-x-circle"></i> Limpar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status"></div>
    <p class="mt-2">Carregando...</p>
  </div>

  <!-- Lista -->
  <div *ngIf="!loading && result.items.length > 0" class="row g-3">
    <div *ngFor="let record of result.items" class="col-md-6 col-lg-4">
      <div class="card h-100">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-start mb-2">
            <h5 class="card-title mb-0">{{record.patientName}}</h5>
            <span class="badge bg-info">{{appointmentTypeLabel(record.appointmentType)}}</span>
          </div>
          <p class="text-muted small mb-2">
            <i class="bi bi-calendar3 me-1"></i> {{fmtDate(record.createdAt)}}
          </p>
          <p class="text-muted small mb-2" *ngIf="record.specialty">
            <i class="bi bi-heart-pulse me-1"></i> {{record.specialty}}
          </p>
          <p class="card-text small" *ngIf="record.chiefComplaint">
            <strong>QP:</strong> {{record.chiefComplaint.substring(0, 80)}}...
          </p>
          <p class="card-text small text-muted" *ngIf="record.diagnosis">
            <strong>Diagnóstico:</strong> {{record.diagnosis.substring(0, 60)}}...
          </p>
          <div class="d-flex gap-2 mt-3">
            <button class="btn btn-sm btn-outline-primary flex-fill" (click)="openModal(record)">
              <i class="bi bi-pencil"></i> Editar
            </button>
            <button class="btn btn-sm btn-outline-danger" (click)="delete(record)">
              <i class="bi bi-trash"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="!loading && result.items.length === 0" class="empty-state">
    <i class="bi bi-clipboard2-x empty-icon"></i>
    <h4>Nenhum prontuário encontrado</h4>
    <button class="btn btn-primary mt-3" (click)="openModal()">
      <i class="bi bi-plus-circle me-2"></i> Adicionar Primeiro Prontuário
    </button>
  </div>

  <!-- Paginação -->
  <div *ngIf="result.totalPages > 1" class="d-flex justify-content-center mt-4">
    <nav>
      <ul class="pagination">
        <li class="page-item" [class.disabled]="!result.hasPrevious">
          <a class="page-link" (click)="onPageChange(result.page - 1)">Anterior</a>
        </li>
        <li class="page-item active">
          <span class="page-link">{{result.page}} / {{result.totalPages}}</span>
        </li>
        <li class="page-item" [class.disabled]="!result.hasNext">
          <a class="page-link" (click)="onPageChange(result.page + 1)">Próxima</a>
        </li>
      </ul>
    </nav>
  </div>
</div>

<!-- Modal Principal -->
<div *ngIf="showModal" class="modal-overlay" (click)="showModal=false"></div>
<div *ngIf="showModal" class="modal-wrapper">
  <div class="modal-panel" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h5 class="modal-title">
        <i class="bi bi-clipboard2-pulse me-2"></i>
        {{editingId ? 'Editar Prontuário' : 'Novo Prontuário'}}
      </h5>
      <button class="btn-close" (click)="showModal=false"></button>
    </div>

    <div class="modal-body">
      <!-- Seleção de Paciente -->
      <div class="mb-3" *ngIf="!editingId">
        <label class="form-label">Paciente *</label>
        <div class="patient-selector" *ngIf="!selectedPatient">
          <input type="text" class="form-control" placeholder="Buscar paciente..."
                 [(ngModel)]="patientSearchTerm" (focus)="showPatientDropdown=true">
          <div class="dropdown-menu show w-100" *ngIf="showPatientDropdown && patientSearchTerm">
            <a class="dropdown-item" *ngFor="let p of patients | slice:0:10" (click)="selectPatient(p)">
              {{p.name}} <small class="text-muted">{{p.cpf}}</small>
            </a>
          </div>
        </div>
        <div class="selected-patient" *ngIf="selectedPatient">
          <span>{{selectedPatient.name}}</span>
          <button class="btn btn-sm btn-link" (click)="selectedPatient=null;form.patientId=null">Alterar</button>
        </div>
      </div>

      <div class="mb-3" *ngIf="editingId && selectedPatient">
        <label class="form-label">Paciente</label>
        <input type="text" class="form-control" [value]="selectedPatient.name" disabled>
      </div>

      <!-- Dados Básicos -->
      <div class="row g-3 mb-3">
        <div class="col-md-6">
          <label class="form-label">Especialidade *</label>
          <input type="text" class="form-control" [(ngModel)]="form.specialty" readonly>
        </div>
        <div class="col-md-3">
          <label class="form-label">Tipo de Atendimento</label>
          <select class="form-select" [(ngModel)]="form.appointmentType">
            <option *ngFor="let t of appointmentTypes" [value]="t.value">{{t.label}}</option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Modalidade</label>
          <select class="form-select" [(ngModel)]="form.modality">
            <option *ngFor="let m of modalities" [value]="m.value">{{m.label}}</option>
          </select>
        </div>
      </div>

      <!-- Queixa Principal -->
      <div class="mb-3">
        <label class="form-label">Queixa Principal</label>
        <textarea class="form-control" rows="3" [(ngModel)]="form.chiefComplaint"></textarea>
      </div>

      <!-- História / Anamnese -->
      <div class="mb-3">
        <label class="form-label">História / Anamnese</label>
        <textarea class="form-control" rows="4" [(ngModel)]="form.medicalHistory"></textarea>
      </div>

      <!-- Antecedentes Relevantes -->
      <div class="mb-3">
        <label class="form-label">Antecedentes Relevantes</label>
        <textarea class="form-control" rows="3" [(ngModel)]="form.relevantHistory"></textarea>
      </div>

      <!-- Avaliação / Exame -->
      <div class="mb-3">
        <label class="form-label">Avaliação / Exame</label>
        <textarea class="form-control" rows="3" [(ngModel)]="form.assessment"></textarea>
      </div>

      <!-- Diagnóstico -->
      <div class="mb-3">
        <label class="form-label">Diagnóstico / Hipótese Diagnóstica</label>
        <textarea class="form-control" rows="3" [(ngModel)]="form.diagnosis"></textarea>
      </div>

      <!-- Observações -->
      <div class="mb-3">
        <label class="form-label">Observações</label>
        <textarea class="form-control" rows="2" [(ngModel)]="form.observations"></textarea>
      </div>

      <!-- Timeline de Evoluções (só para edição) -->
      <div *ngIf="editingId" class="mt-4">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6><i class="bi bi-clock-history me-2"></i> Evoluções Clínicas</h6>
          <button class="btn btn-sm btn-outline-primary" (click)="openEvolutionModal()">
            <i class="bi bi-plus"></i> Adicionar Evolução
          </button>
        </div>

        <div *ngIf="evolutions.length === 0" class="text-muted text-center py-3">
          Nenhuma evolução registrada
        </div>

        <div class="timeline">
          <div *ngFor="let ev of evolutions" class="timeline-item">
            <div class="timeline-marker"></div>
            <div class="timeline-content">
              <small class="text-muted">{{fmtDate(ev.evolutionDate)}}</small>
              <p class="mb-0">{{ev.notes}}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Anexos (só para edição) -->
      <div *ngIf="editingId" class="mt-4">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6><i class="bi bi-paperclip me-2"></i> Anexos</h6>
          <label class="btn btn-sm btn-outline-primary mb-0">
            <i class="bi bi-upload"></i> Upload
            <input type="file" class="d-none" (change)="onFileSelect($event)"
                   accept=".pdf,.jpg,.jpeg,.png,.doc,.docx">
          </label>
        </div>

        <div *ngIf="uploadingFile" class="text-center py-2">
          <div class="spinner-border spinner-border-sm"></div> Enviando...
        </div>

        <div *ngIf="attachments.length === 0 && !uploadingFile" class="text-muted text-center py-3">
          Nenhum anexo
        </div>

        <div class="list-group">
          <div *ngFor="let att of attachments" class="list-group-item d-flex justify-content-between align-items-center">
            <div>
              <i class="bi bi-file-earmark-pdf me-2" *ngIf="att.fileType === 'pdf'"></i>
              <i class="bi bi-file-earmark-image me-2" *ngIf="att.fileType !== 'pdf'"></i>
              <a [href]="att.fileUrl" target="_blank">{{att.fileName}}</a>
              <small class="text-muted d-block">{{att.fileSizeKB | number:'1.0-0'}} KB</small>
            </div>
            <button class="btn btn-sm btn-outline-danger" (click)="deleteAttachment(att)"
                    [disabled]="deletingAttachmentId === att.id">
              <i class="bi bi-trash"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="showModal=false" [disabled]="saving">Cancelar</button>
      <button class="btn btn-primary" (click)="save()" [disabled]="saving">
        <span *ngIf="!saving"> {{ editingId ? 'Salvar Alterações' : 'Salvar' }}</span>
        <span *ngIf="saving"><span class="spinner-border spinner-border-sm me-2"></span> Salvando...</span>
      </button>
      <button *ngIf="editingId" class="btn btn-info" (click)="exportPdf()">
        <i class="bi bi-file-pdf me-2"></i> Exportar PDF
      </button>
    </div>
  </div>
</div>

<!-- Modal de Evolução -->
<div *ngIf="showEvolutionModal" class="modal-overlay" (click)="showEvolutionModal=false"></div>
<div *ngIf="showEvolutionModal" class="modal-wrapper">
  <div class="modal-panel small-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h5 class="modal-title"><i class="bi bi-plus-circle me-2"></i> Adicionar Evolução</h5>
      <button class="btn-close" (click)="showEvolutionModal=false"></button>
    </div>
    <div class="modal-body">
      <div class="row g-3 mb-3">
        <div class="col-md-8">
          <label class="form-label">Data</label>
          <div class="date-input-wrapper">
            <input #evolutionDateInput type="text" class="form-control"
                   [(ngModel)]="evolutionDateDisplay"
                   (input)="onEvolutionDateInput($event)"
                   placeholder="dd/MM/yyyy"
                   maxlength="10">
            <button type="button" class="date-picker-btn" (click)="toggleEvolutionDatePicker()">
              <i class="bi bi-calendar3"></i>
            </button>
          </div>
        </div>
        <div class="col-md-4">
          <label class="form-label">Hora</label>
          <input type="time" class="form-control"
                 [ngModel]="evolutionForm.evolutionDate?.slice(11, 16)"
                 (ngModelChange)="evolutionForm.evolutionDate = evolutionForm.evolutionDate.slice(0, 11) + $event">
        </div>
      </div>
      <div class="mb-3">
        <label class="form-label">Anotações *</label>
        <textarea class="form-control" rows="5" [(ngModel)]="evolutionForm.notes"></textarea>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="showEvolutionModal=false" [disabled]="savingEvolution">Cancelar</button>
      <button class="btn btn-primary" (click)="saveEvolution()" [disabled]="savingEvolution">
        <span *ngIf="!savingEvolution">Adicionar</span>
        <span *ngIf="savingEvolution"><span class="spinner-border spinner-border-sm me-2"></span> Salvando...</span>
      </button>
    </div>
  </div>
</div>

<!-- ================================================================== -->
<!-- DATEPICKERS (renderizados fora dos containers para posicionamento correto) -->
<!-- ================================================================== -->

<!-- Datepicker - Filter Start Date -->
<div class="datepicker-overlay" *ngIf="showStartDatePicker" (click)="showStartDatePicker = false"></div>
<div class="datepicker-popup" *ngIf="showStartDatePicker"
     [style.top]="startPickerTop"
     [style.left]="startPickerLeft"
     (click)="$event.stopPropagation()">
  <div class="datepicker-header">
    <button type="button" class="btn-nav" (click)="startPickerPreviousMonth()">
      <i class="bi bi-chevron-left"></i>
    </button>
    <span class="datepicker-month">{{ getStartPickerMonthYear() | titlecase }}</span>
    <button type="button" class="btn-nav" (click)="startPickerNextMonth()">
      <i class="bi bi-chevron-right"></i>
    </button>
  </div>

  <div class="datepicker-weekdays">
    <div *ngFor="let day of weekDays" class="datepicker-weekday">{{ day }}</div>
  </div>

  <div class="datepicker-days">
    <div
      *ngFor="let date of startPickerDays"
      class="datepicker-day"
      [class.other-month]="!startPickerIsCurrentMonth(date)"
      [class.today]="startPickerIsToday(date)"
      [class.selected]="startPickerIsSelected(date)"
      (click)="startPickerSelectDate(date)">
      {{ date.getDate() }}
    </div>
  </div>

  <div class="datepicker-footer">
    <button type="button" class="btn btn-sm btn-link" (click)="startPickerSelectToday()">
      Hoje
    </button>
  </div>
</div>

<!-- Datepicker - Filter End Date -->
<div class="datepicker-overlay" *ngIf="showEndDatePicker" (click)="showEndDatePicker = false"></div>
<div class="datepicker-popup" *ngIf="showEndDatePicker"
     [style.top]="endPickerTop"
     [style.left]="endPickerLeft"
     (click)="$event.stopPropagation()">
  <div class="datepicker-header">
    <button type="button" class="btn-nav" (click)="endPickerPreviousMonth()">
      <i class="bi bi-chevron-left"></i>
    </button>
    <span class="datepicker-month">{{ getEndPickerMonthYear() | titlecase }}</span>
    <button type="button" class="btn-nav" (click)="endPickerNextMonth()">
      <i class="bi bi-chevron-right"></i>
    </button>
  </div>

  <div class="datepicker-weekdays">
    <div *ngFor="let day of weekDays" class="datepicker-weekday">{{ day }}</div>
  </div>

  <div class="datepicker-days">
    <div
      *ngFor="let date of endPickerDays"
      class="datepicker-day"
      [class.other-month]="!endPickerIsCurrentMonth(date)"
      [class.today]="endPickerIsToday(date)"
      [class.selected]="endPickerIsSelected(date)"
      (click)="endPickerSelectDate(date)">
      {{ date.getDate() }}
    </div>
  </div>

  <div class="datepicker-footer">
    <button type="button" class="btn btn-sm btn-link" (click)="endPickerSelectToday()">
      Hoje
    </button>
  </div>
</div>

<!-- Datepicker - Evolution Date -->
<div class="datepicker-overlay" *ngIf="showEvolutionDatePicker" (click)="showEvolutionDatePicker = false"></div>
<div class="datepicker-popup" *ngIf="showEvolutionDatePicker"
     [style.top]="evolutionPickerTop"
     [style.left]="evolutionPickerLeft"
     (click)="$event.stopPropagation()">
  <div class="datepicker-header">
    <button type="button" class="btn-nav" (click)="evolutionPickerPreviousMonth()">
      <i class="bi bi-chevron-left"></i>
    </button>
    <span class="datepicker-month">{{ getEvolutionPickerMonthYear() | titlecase }}</span>
    <button type="button" class="btn-nav" (click)="evolutionPickerNextMonth()">
      <i class="bi bi-chevron-right"></i>
    </button>
  </div>

  <div class="datepicker-weekdays">
    <div *ngFor="let day of weekDays" class="datepicker-weekday">{{ day }}</div>
  </div>

  <div class="datepicker-days">
    <div
      *ngFor="let date of evolutionPickerDays"
      class="datepicker-day"
      [class.other-month]="!evolutionPickerIsCurrentMonth(date)"
      [class.today]="evolutionPickerIsToday(date)"
      [class.selected]="evolutionPickerIsSelected(date)"
      (click)="evolutionPickerSelectDate(date)">
      {{ date.getDate() }}
    </div>
  </div>

  <div class="datepicker-footer">
    <button type="button" class="btn btn-sm btn-link" (click)="evolutionPickerSelectToday()">
      Hoje
    </button>
  </div>
</div>
